import { useEffect, useRef, useState } from 'react';

export const useGetExistingResourceUrl = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getExistingUrl = async (url: string): Promise<string | undefined> => {
    try {
      setIsLoading(true);
      const response = await fetch(url, { method: 'HEAD' });
      if (response.ok) {
        return url;
      }
      return undefined;
    } catch (error) {
      console.error('Error checking resource file:', error);
      return undefined;
    } finally {
      setIsLoading(false);
    }
  };

  return { getExistingUrl, isLoading };
};

export const useGetExistingImageUrl = (url: string) => {
  const [existingUrl, setExistingUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const cache = useRef<Record<string, boolean>>({});

  useEffect(() => {
    if (cache.current[url] !== undefined) {
      setExistingUrl(cache.current[url] ? url : undefined);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const img = new Image();
    img.onload = () => {
      cache.current[url] = true;
      setExistingUrl(url);
      setIsLoading(false);
    };
    img.onerror = () => {
      cache.current[url] = false;
      setExistingUrl(undefined);
      setIsLoading(false);
    };
    img.src = url;
  }, [url]);

  return { existingUrl, isLoading };
};
